//returns a new selection state with the location of the entity specified
export default function getActiveEntityRange(editorState) {
  const contentState = editorState.getCurrentContent();
  const selection = editorState.getSelection();
  const startKey = selection.getStartKey();
  const currentBlock = contentState.getBlockForKey(startKey);
  const currentEntityKey = currentBlock.getEntityAt(selection.getStartOffset());

  //return current selection if startOffset is not at an entity
  if (currentEntityKey === null) {
    return selection;
  } else {
    let startOffset, endOffset;

    currentBlock.findEntityRanges(
      char => {
        return char.getEntity() === currentEntityKey;
      },
      (start, end) => {
        startOffset = start;
        endOffset = end;
      }
    );

    return selection.merge({
      anchorKey: startKey,
      anchorOffset: startOffset,
      focusKey: startKey,
      focusOffset: endOffset,
      isBackward: false,
    });
  }
}
